import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VisibilityService {
  private readonly STORAGE_KEY = 'ngx_hide_values';
  private readonly hidden$ = new BehaviorSubject<boolean>(this.loadFromStorage());

  readonly hideValues$ = this.hidden$.asObservable();

  constructor() {
    this.applyBodyClass(this.hidden$.value);
  }

  toggle(): void {
    const next = !this.hidden$.value;
    this.hidden$.next(next);
    localStorage.setItem(this.STORAGE_KEY, String(next));
    this.applyBodyClass(next);
  }

  get isHidden(): boolean {
    return this.hidden$.value;
  }

  private loadFromStorage(): boolean {
    return localStorage.getItem(this.STORAGE_KEY) === 'true';
  }

  private applyBodyClass(hide: boolean): void {
    document.body.classList.toggle('values-hidden', hide);
  }
}
